import { render, staticRenderFns } from "./statiStical.vue?vue&type=template&id=11d4bc35&"
import script from "./statiStical.vue?vue&type=script&lang=js&"
export * from "./statiStical.vue?vue&type=script&lang=js&"
import style0 from "./statiStical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d4bc35')) {
      api.createRecord('11d4bc35', component.options)
    } else {
      api.reload('11d4bc35', component.options)
    }
    module.hot.accept("./statiStical.vue?vue&type=template&id=11d4bc35&", function () {
      api.rerender('11d4bc35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/statiStical.vue"
export default component.exports